import styles from './financialoverview.module.css'
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';
import { FormControl, MenuItem, Select } from '@mui/material';
import { ArrowDownRight, ArrowUpRight } from 'react-feather';
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axios from "axios";
import { DashCardLoaderSmall } from '../../../../../components/LoaderC';

const PartialVerticalCursor = (props) => {
    const { points, stroke, chartHeight } = props;
    if (!points || !points.length) return null;
    const { x, y } = points[0];

    return (<line x1={x} y1={y} x2={x} y2={chartHeight} stroke={stroke || "#502688"} strokeWidth={2} />);
}

const CustomActiveDot = (props) => {
    const { cx, cy, stroke, payload } = props;

    return (payload?.balance ? <g>
        <line x1={cx} y1={cy} x2={cx} y2={183} stroke={"#502688"} strokeWidth={1} />
        <circle cx={cx} cy={cy} r={5} fill="#502688" stroke={stroke} strokeWidth={1} />
    </g> : null);
}

const formatToAbbrCurrency = (amount, currency = "USD") => {
    let formatted;

    if (Math.abs(amount) >= 1.0e12) {
        formatted = (amount / 1.0e12).toFixed(2) + "T";
    } else if (Math.abs(amount) >= 1.0e9) {
        formatted = (amount / 1.0e9).toFixed(2) + "B";
    } else if (Math.abs(amount) >= 1.0e6) {
        formatted = (amount / 1.0e6).toFixed(2) + "M";
    } else if (Math.abs(amount) >= 1.0e3) {
        formatted = (amount / 1.0e3).toFixed(2) + "K";
    } else {
        formatted = amount.toFixed(2);
    }

    return '$' + formatted;

    //return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(0).replace(/\d/g, '') + formatted;
}

const FinancialOverview = ({ selectedProperty }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [contentLoading, setContentLoading] = useState(true);
    const [currentTime, setCurrentTime] = useState('7-days');
    const [overviewData, setOverviewData] = useState([]);
    const [finalData, setFinalData] = useState(null);
    const [finalData2, setFinalData2] = useState(null);
    const [noData, setNoData] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setContentLoading(true);
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            var URL = process.env.REACT_APP_USER_API_URL + "v1/dashboard/financial-overview-data/" + currentTime;
            if (selectedProperty !== '' && selectedProperty > 0) {
                URL = process.env.REACT_APP_USER_API_URL + "v1/dashboard/financial-overview-data/" + currentTime + '?property_id=' + selectedProperty;
            }

            await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);

                let dataArr = response.data.data;
                setOverviewData(dataArr?.data);
                setFinalData(dataArr?.final);

                if (dataArr?.data?.length > 0) {
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            }).catch((error) => {
                setContentLoading(false);
            });
        }

        fetchData();
    }, [getAccessTokenSilently, currentTime, selectedProperty]);

    return (<div className={`${styles.Card}`}>

        <div className={`${styles.InsideCard}`}>
            {contentLoading && (<div className={`${styles.LoaderDash3}`}>
                <div><DashCardLoaderSmall /></div>
            </div>)}

            {!contentLoading && (<>
                {!noData && (<>
                    <div className={`${styles.HeadDes}`}>
                        <div>
                            <p className={`${styles.CardTitle}`}>Financial Overview</p>
                            <p className={`${styles.CardAmount}`}>{(finalData2 ? finalData2?.balance?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2
                            }) : (finalData ? finalData?.balance?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2
                            }) : '0.00'))}</p>
                        </div>

                        <div className={`${styles.FOFilterSec}`}>
                            {finalData2 ? <p className={`${styles.FilterText}`}>{finalData2?.label}</p> : <div className={`${styles.SelectFilterForFO} FormGroup WithOurBorder`}>
                                <FormControl fullWidth>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        defaultValue={currentTime}
                                        onChange={(e) => {
                                            setCurrentTime(e.target.value);
                                        }}
                                    >
                                        <MenuItem value={'7-days'}>Last 7 days</MenuItem>
                                        <MenuItem value={'30-days'}>Last 30 days</MenuItem>
                                        <MenuItem value={'90-days'}>Last 90 days</MenuItem>
                                        <MenuItem value={'month-to-date'}>Month to date</MenuItem>
                                        <MenuItem value={'year-to-date'}>Year to date</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>}

                            <div className={`${styles.FOUpDownSec}`}>
                                {(finalData || finalData2) && <div className={`${styles.Up}`}>
                                    <ArrowUpRight /> {finalData2 ? formatToAbbrCurrency(finalData2?.day_income) : formatToAbbrCurrency(finalData?.day_income)}
                                </div>}
                                {((finalData && finalData?.day_expense > 0) || (finalData2 && finalData2?.day_expense > 0)) && <div className={`${styles.Down}`}>
                                    <ArrowDownRight /> -{finalData2 ? formatToAbbrCurrency(finalData2?.day_expense) : formatToAbbrCurrency(finalData?.day_expense)}
                                </div>}
                            </div>
                        </div>
                    </div>
                    <ResponsiveContainer width="100%" height={220}>
                        <AreaChart
                            width={500}
                            height={220}
                            data={overviewData}
                            syncId="anyId"
                            margin={{ top: 0, right: 0, left: 0, bottom: 6 }}
                        >
                            <XAxis
                                dataKey="legend"
                                axisLine={false}
                                tickLine={false}
                                tick={{ fill: '#70707d', fontSize: 12, dy: 6 }}
                                tickFormatter={(value, index) => {
                                    if (index === 0 || index === overviewData.length - 1) {
                                        return "";
                                    }
                                    if (currentTime === "30-days") {
                                        if (index % 5 > 0) {
                                            return "";
                                        }
                                    }
                                    if (currentTime === "90-days") {
                                        if (index % 15 > 0) {
                                            return "";
                                        }
                                    }
                                    if (currentTime === "month-to-date") {
                                        if (index % 5 > 0) {
                                            return "";
                                        }
                                    }
                                    if (currentTime === "year-to-date") {
                                        if (index % 20 > 0) {
                                            return "";
                                        }
                                    }
                                    return value;
                                }}
                            />
                            <defs>
                                <linearGradient id="myGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stopColor="#502688" stopOpacity={0.7} />
                                    <stop offset="100%" stopColor="#502688" stopOpacity={0.1} />
                                </linearGradient>
                            </defs>
                            <Tooltip
                                cursor={<PartialVerticalCursor />}
                                content={({ active, payload, label }) => {
                                    if (active && payload && payload.length) {
                                        if (payload[0].payload?.balance) {
                                            setFinalData2(payload[0].payload);
                                        } else {
                                            setFinalData2(null);
                                        }
                                    } else {
                                        setFinalData2(null);
                                    }
                                    return null;
                                }}
                            />
                            <Area
                                type="monotone"
                                dataKey="balance"
                                stroke="#502688"
                                fill="url(#myGradient)"
                                activeDot={<CustomActiveDot />}
                            />
                        </AreaChart>
                    </ResponsiveContainer>
                </>)}


                {noData && (<>
                    <div className={`${styles.HeadDes}`}>
                        <div>
                            <p className={`${styles.CardTitle}`}>Financial Overview</p>
                        </div>
                    </div>
                    <div className={`${styles.NoDataSec}`}>
                        <div className={`${styles.NoDataIMG}`}><img src="/static/img/financialOverview.png" alt="" /></div>
                        <p className={`${styles.NoDataText}`}>Oops!</p>
                        <p className={`${styles.NoDataTextSub}`}>Add income and expenses to see your overview.</p>
                    </div>
                </>)}
            </>)}
        </div>
    </div >);
}

export default FinancialOverview;